import { render, staticRenderFns } from "./OpportunityTableForLazyLoadingWithResize.vue?vue&type=template&id=63076164&scoped=true"
import script from "./OpportunityTableForLazyLoadingWithResize.vue?vue&type=script&lang=js"
export * from "./OpportunityTableForLazyLoadingWithResize.vue?vue&type=script&lang=js"
import style0 from "./OpportunityTableForLazyLoadingWithResize.vue?vue&type=style&index=0&id=63076164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63076164",
  null
  
)

export default component.exports